import styled from "@emotion/styled";
import { XIcon16Light } from "@skbkontur/icons/XIcon16Light";

import { theme } from "../../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Layout = styled.div(props => ({
    display: "flex",
    alignItems: "start",
    gap: "4px",

    marginTop: "8px",
    padding: "12px",

    borderRadius: "8px",
    backgroundColor: theme(props).document.bodyBackgroundColor,
}));

export const Body = styled.div({
    display: "flex",
    flexFlow: "column",
    gap: "2px",
});

export const Caption = styled.div(() => ({
    fontWeight: "700",
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0px",
}));

export const Underline = styled.span({
    textDecoration: "underline",
    textDecorationColor: "#AEAEAE",
    textDecorationThickness: "0.1em",
    textUnderlineOffset: "25%",
});

export const Description = styled.div<{ paragraph?: boolean }>(({ paragraph = true }) => ({
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0px",

    marginTop: paragraph ? "10px" : 0,
}));

export const CloseIcon = styled(XIcon16Light)(props => ({
    marginTop: "-4px",
    marginRight: "-4px",

    userSelect: "none",
    color: theme(props).icons.color,
    cursor: "pointer",

    ":hover": {
        color: theme(props).icons.hoverColor,
    },
}));
